import React from "react"
//import I18n from "i18n-js/index.js.erb"

class NightAuditNavigation extends React.Component{
  constructor(props) {
    super(props);
    this.state = {

    };
  };

  render() {
    if(this.props.step != "confirmation"){
      return(
        <div className="steps">
          <ul className="nav nav-wizard">
            <li className={this.props.step === "folio_items" ? 'active' : ''}><a href="#" onClick={() => this.props.changeStep("folio_items")} data-step={'folio_items'}>{I18n.t('folio_items')}</a></li>
            <li className={this.props.step === "payments" ? 'active' : ''}><a href="#" onClick={() => this.props.changeStep("payments")} data-step={'payments'}>{I18n.t('payments')}</a></li>
            <li className={this.props.step === "cc_authorizations" ? 'active' : ''}><a href="#" onClick={() => this.props.changeStep("cc_authorizations")} data-step={'cc_authorizations'}>{I18n.t('authorizations')}</a></li>
            <li className={this.props.step === "no_shows" ? 'active' : ''}><a href="#" onClick={() => this.props.changeStep("no_shows")} data-step={'no_shows'}>{I18n.t('no_shows')}</a></li>
            {/* {this.props.read_only ? null : <li className={this.props.step === "confirmation" ? 'active' : ''}><a href="#" onClick={() => this.props.changeStep("confirmation")} data-step={'confirmation'}>{I18n.t('confirmation')}</a></li>} */}
          </ul>
        </div>
      );
    } else {
      return null;
    };
  };
  

};

export default NightAuditNavigation